export function validator(values) {
    const data = values

    function validateStudent () {
        return data.student.residency !== undefined
                && data.student.classification !== undefined
                && data.student.studyArea !== undefined
                && data.student.techDropdown !== undefined
                && !(data.student.classification_specific === undefined && (data.student.classification === 4 || data.student.classification === 3))
    } 
    
    function validateHouseMeal () {
        return data.house_meal.housingType !== undefined && data.house_meal.mealPlan !== undefined
    }

    let invalid = []
    if (!validateStudent()) invalid.push("student")
    if (!validateHouseMeal()) invalid.push("house_meal")
    return invalid

}